import React, { Component } from 'react'
import { connect } from 'react-redux'
import { loginUser, logoutUser, reAuthUser, socialAuthUser, toggleLoginDialog, updateUserInfo } from '../../redux/actions/authActions';
import LoginDialog from '../../components/dialogs/LoginDialog';
import { showDialog } from '../../redux/actions/MainDialog';
import AfterPayment from '../../components/JH/personalJourney/AfterPayment';
import JourneyData from '../../components/JH/personalJourney/JourneyData';
import '../../styles/AlmuniFont.css'
import { push } from '../../components/routerPatch';

class JourneyViewC extends Component {
    state = {
    }

    componentDidMount() {
        const searchParams = new URLSearchParams(window.location.search);
        const afterPayment = (searchParams.get("afterPayment") === 'true')
        const token = searchParams.get("token")
        const error = searchParams.get("error")

        if (afterPayment){
            if (token){
                this.setState({
                    afterPayment: true,
                    afterPaymentToken: token
                })
            } else {
                this.setState({
                    afterPayment: true,
                    afterPaymentError: error || 'Something went wrong'
                })
                //this.showMessage('After Payment', 'Invalid Token, Please contact us')
                /*const { dispatch } = this.props
                dispatch(reAuthUser());*/
            }

            const { dispatch } = this.props
            dispatch(push('/'));
        } else {
            const { dispatch } = this.props
            dispatch(reAuthUser());
        }
    }

    setJourneyData = newJourneyData => {
        let newData = {...this.state.data}

        newData.journeyData = newJourneyData

        this.setState({
            data: newData
        })
    }

    showLoginDialog = () => {
        const { dispatch } = this.props
        dispatch(toggleLoginDialog(true))
    };

    handleLogOut = () => {
        const { dispatch } = this.props
        dispatch(logoutUser(()=>{
            this.setState({ 
                anchorEl: null
            });
        }));
    }

    handleLogin = (checkParam=false) => {
		const { dispatch } = this.props

        const params = new URLSearchParams(document.location.search);

        if (!checkParam || !params.get("newPassword")){
            dispatch(toggleLoginDialog(true, 'signIn'))
        }
    }

    handleSetSection = section => {
        const { dispatch } = this.props
        dispatch(toggleLoginDialog(true, section))
    }

	closeLoginDialog = () => {
        const { dispatch } = this.props
        dispatch(toggleLoginDialog(false))
    };

    showMessage = (title, content) => {
        const { dispatch } = this.props
        dispatch(showDialog(title, content))
    }

    handleLoginDialog = (payload) => {
        this.props.dispatch(
            loginUser(payload, () => {
                //this.closeLoginDialog();
                //this.clearForm();
                /*const { from } = this.props.location.state || {
                    from: { pathname: "/profile" }
                };
                this.props.history.push(from.pathname);*/
            })
        );
    }

    loginAfterPayment = token => {
        const {dispatch} = this.props
        dispatch(socialAuthUser(token, () => {}));

        this.setState({
            afterPayment: undefined, 
            afterPaymentToken: undefined,
            afterPaymentError: undefined
        })
    }

    showMessageDialog = (title, content, pre) => {
        const {dispatch} = this.props

        dispatch(showDialog(title, content, pre))
    }

    updateUserData = userData => {
        const { dispatch } = this.props
        dispatch(updateUserInfo({userInfo: userData}, true));
    }

    changeRoute = (location) => {    
        this.setState({ anchorEl: null });

        const { dispatch } = this.props
        dispatch(push('/' + location));
    }

    render() {
        const { loginErrors, openDialog, loginChecked, section } = this.props

        const { afterPayment, afterPaymentToken, afterPaymentError } = this.state

        return (
            <>
                {afterPayment?<AfterPayment token={afterPaymentToken} error={afterPaymentError} loginAfterPayment={this.loginAfterPayment}/>:<>
                <LoginDialog
                    open={openDialog && loginChecked}
                    section={section}
                    onClose={this.closeLoginDialog}
                    handleLogin={this.handleLoginDialog}
                    handleSetSection={this.handleSetSection}
                    loginErrors={loginErrors}
                    showMessage={this.showMessage}
                    redirectPath={window.location.pathname}
                />
                <JourneyData {...this.props}
                    disabled={this.state.loading}
                    handleLogOut={this.handleLogOut} 
                    handleLogin={this.handleLogin} 
                    showMessageDialog={this.showMessageDialog}
                    updateUserData={this.updateUserData}
                    changeRoute={this.changeRoute}
                />
                </>}
            </>
        )
    }
}

function mapStateToProps(state) {
    const { isAuthed, userInfo, loginErrors, openDialog, loginChecked, section } = state.authUser;

    const isJHUser = (userInfo && userInfo.isJHUser)
    const isActiveJHUser = (userInfo && userInfo.isActiveJHUser)
    const userId = (userInfo && userInfo._id)
    const isAdmin = (userInfo && (userInfo.isAdmin || userInfo.isJHAdmin))

    return {
        isAuthed, userInfo, loginErrors, openDialog, loginChecked, section, isJHUser, isActiveJHUser, userId, isAdmin
    }
}

export default connect(mapStateToProps)(JourneyViewC)